/* jshint esversion: 6 */

export default class FaqDirective {

	constructor(
		DomService
	) {
		this.domService = DomService;
		this.restrict = 'A';
	}
	link(scope, element, attributes, controller) {
		const node = element[0];
		const abstract = node.querySelector('.abstract');
		const content = node.querySelector('.content');
		const more = node.querySelector('.btn--discover');
		const isSeoAccordion = node.classList.contains('seo-section__accordion');
		const getCollapsedHeight = () => {
			if (!isSeoAccordion) {
				return 0;
			}

			const maxHeight = window.getComputedStyle(content).maxHeight;
			const collapsedHeight = parseFloat(maxHeight);
			return Number.isFinite(collapsedHeight) ? collapsedHeight : 0;
		};
		const collapsedHeight = getCollapsedHeight();
		TweenMax.set(content, { height: collapsedHeight });
		// Inizializza attributi ARIA per l'accessibilità
		const initializeAccessibility = () => {
			const faqId = `faq-${Math.random().toString(36).substr(2, 9)}`;
			const contentId = `${faqId}-content`;

			abstract.setAttribute('aria-expanded', 'false');
			abstract.setAttribute('aria-controls', contentId);
			content.setAttribute('id', contentId);
			content.setAttribute('aria-hidden', 'true');

			// Rendi i link dentro al contenuto non navigabili inizialmente
			setLinksTabIndex(false);
		};

		// Gestisce la navigabilità dei link interni
		const setLinksTabIndex = (isNavigable) => {
			const links = content.querySelectorAll('a, button, input, select, textarea, [tabindex]');
			links.forEach(link => {
				if (isNavigable) {
					// Ripristina il tabindex originale o rimuovilo se era 0
					const originalTabIndex = link.getAttribute('data-original-tabindex');
					if (originalTabIndex !== null) {
						if (originalTabIndex === '0' || originalTabIndex === '') {
							link.removeAttribute('tabindex');
						} else {
							link.setAttribute('tabindex', originalTabIndex);
						}
						link.removeAttribute('data-original-tabindex');
					}
				} else {
					// Salva il tabindex originale e imposta -1
					const currentTabIndex = link.getAttribute('tabindex');
					if (currentTabIndex !== '-1') {
						link.setAttribute('data-original-tabindex', currentTabIndex || '0');
						link.setAttribute('tabindex', '-1');
					}
				}
			});
		};
		const toggleFaq = () => {
			if (node.classList.contains('active')) {
				// Chiudi la FAQ
				node.classList.remove('active');
				if (more) more.classList.remove('active');
				abstract.setAttribute('aria-expanded', 'false');
				content.setAttribute('aria-hidden', 'true');

				// Rendi i link non navigabili
				setLinksTabIndex(false);

				TweenMax.to(content, 0.7, {
					height: collapsedHeight,
					ease: Power2.easeInOut,
					onComplete: () => {
						// content.removeAttribute('style');
					}
				});
			} else {
				// Apri la FAQ
				node.classList.add('active');
				abstract.setAttribute('aria-expanded', 'true');
				content.setAttribute('aria-hidden', 'false');

				// Rendi i link navigabili
				setLinksTabIndex(true);

				TweenMax.set(content, { height: 'auto' });
				const height = content.offsetHeight;
				TweenMax.set(content, { height: collapsedHeight });
				TweenMax.to(content, 0.7, {
					height: height,
					ease: Power2.easeInOut,
					onComplete: () => {
						content.removeAttribute('style');
					}
				});
			}
		};
		const onAbstractClicked = toggleFaq;

		const onKeyDown = (event) => {
			// Supporta Enter (13) e Spazio (32) per attivare la FAQ
			if (event.keyCode === 13 || event.keyCode === 32) {
				event.preventDefault();
				event.stopPropagation();
				toggleFaq();
			}
		};

		const onMoreClicked = () => {
			if (more.classList.contains('active')) {
				more.classList.remove('active');
			} else {
				more.classList.add('active');
			}
		};

		const addListeners = () => {
			// Listener per il click sull'abstract
			abstract.addEventListener('click', onAbstractClicked);
			// Listener per la tastiera sull'elemento principale (node)
			node.addEventListener('keydown', onKeyDown);
			// more.addEventListener('click', onMoreClicked);
		};

		const removeListeners = () => {
			abstract.removeEventListener('click', onAbstractClicked);
			node.removeEventListener('keydown', onKeyDown);
			// more.removeEventListener('click', onMoreClicked);
		};

		initializeAccessibility();
		addListeners();
		scope.$on('destroy', () => {
			removeListeners();
		});
	}

	static factory(DomService) {
		return new FaqDirective(DomService);
	}

}

FaqDirective.factory.$inject = ['DomService'];
